import { gql } from '@apollo/client';

export const GET_REPORT_TYPES_QUERY = gql`
query reportTypes{
    reportTypes {
      edges{
        node{
          reportType
          reportLabel
          reportDescription
          reportConfigUrl
        }
      }
    }
  }`;